import Image from "next/image";

import MouseLeft from "./assets/mouse-left-click.webp";
import MouseWheel from "./assets/mouse-mousewheel.webp";
import MouseMove from "./assets/mouse-move.webp";
import MouseRight from "./assets/mouse-right-click.webp";
import styles from "./mouse.module.css";

const icons = {
    left: MouseLeft,
    right: MouseRight,
    wheel: MouseWheel,
    move: MouseMove,
};

interface MouseProps {
    type: keyof typeof icons;
    label: string;
    width?: number;
}

export const Mouse = ({ type, label, width = 80 }: MouseProps) => {
    return (
        <div className={styles.mouse}>
            <div className={styles.imageWrapper}>
                <Image width={width} src={icons[type]} alt={`Mouse ${type}`} />
            </div>
            <span>{label}</span>
        </div>
    );
};
